import { AudiusMoodPreset } from './audiusTypes';

export const DEFAULT_AUDIUS_MOOD = 'ambient';

export const AUDIUS_MOOD_PRESETS: AudiusMoodPreset[] = [
  {
    id: 'ambient',
    label: 'Ambient',
    description: 'Domyślna, spokojna i przestrzenna playlista.',
    queries: [
      'ambient electronic',
      'cinematic ambient',
      'downtempo ambient',
      'atmospheric chill',
    ],
  },
  {
    id: 'focus',
    label: 'Focus',
    description: 'Równe tempo do skupienia i gry.',
    queries: [
      'lofi focus',
      'study beats instrumental',
      'chill instrumental',
      'minimal electronic',
    ],
  },
  {
    id: 'mellow',
    label: 'Mellow',
    description: 'Lżejszy, bardziej miękki vibe.',
    queries: [
      'chillhop mellow',
      'dream pop chill',
      'indie chill',
      'soft electronic',
    ],
  },
  {
    id: 'dark',
    label: 'Dark',
    description: 'Cięższy, nocny klimat.',
    queries: [
      'dark synthwave',
      'industrial electronic',
      'phonk dark',
      'cyberpunk soundtrack',
    ],
  },
  {
    id: 'energetic',
    label: 'Energetic',
    description: 'Szybsza, bardziej agresywna playlista.',
    queries: [
      'drum and bass',
      'electro house',
      'trap electronic',
      'bass music',
    ],
  },
];
